module.exports = __webpack_public_path__ + "syndication/Components/PersistentActions/facebook.f019805bebf4f842e3355f0b8dd0c1df.svg";